import {
  WhmCard,
  WhmCardContent,
  WhmFlexDataGrid,
  WhmGridColDef,
  WhmSkeleton,
} from "@securitize/reactjs-whm";
import { translationKeys } from "../../../../../contexts/I18nContext";
import { useTranslation } from "../../../../../hooks/useTranslation";
import { useLocaleText } from "../useLocaleText";

const columnProps = {
  disableReorder: true,
  disableColumnMenu: true,
  sortable: false,
  hideSortIcons: true,
  renderCell: () => (
    <WhmSkeleton variant="rounded" sx={{ marginTop: "1rem" }} />
  ),
};

export const DataGridSkeleton: React.FC = () => {
  const { getTranslation: t } = useTranslation();
  const localeText = useLocaleText();

  const rowsPerPageOptions = [10, 25, 50];
  const columnsVisibility = { id: false };

  const columns: WhmGridColDef[] = [
    {
      field: "id",
      headerName: "ID",
      width: 90,
      renderCell: () => <WhmSkeleton variant="rounded" />,
    },
    {
      field: "createdAt",
      headerName: t(translationKeys.DOCUMENT_DATAGRID_COLUMN_DATE_HEADER),
      type: "string",
      flex: 1,
      ...columnProps,
    },
    {
      field: "showType",
      headerName: t(translationKeys.DOCUMENT_DATAGRID_COLUMN_TYPE_HEADER),
      flex: 1,
      ...columnProps,
    },
    {
      field: "relatedWith",
      headerName: t(translationKeys.DOCUMENT_DATAGRID_COLUMN_RELATED_HEADER),
      flex: 1,
      ...columnProps,
    },
    {
      field: "download",
      headerName: "",
      width: 20,
      ...columnProps,
    },
    {
      field: "actions",
      headerName: "",
      width: 20,
      ...columnProps,
    },
  ];

  return (
    <WhmFlexDataGrid
      localeText={localeText}
      sx={{
        border: 0,
        ".MuiDataGrid-columnSeparator": { display: "none" },
      }}
      disableColumnMenu
      disableColumnResize
      // @ts-ignore
      columns={columns}
      // @ts-ignore
      rows={Array.from({ length: 5 }).map((_, ix) => ({ id: ix }))}
      rowsPerPageOptions={rowsPerPageOptions}
      clientSide={true}
      initialPage={0}
      initialPageSize={rowsPerPageOptions[1]}
      columnsVisibility={columnsVisibility}
      checkboxSelection={false}
      disableRowSelectionOnClick={true}
      CardComponent={() => (
        <WhmCard sx={{ marginBottom: "6px" }}>
          <WhmCardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              paddingBottom: "16px !important",
            }}
          >
            <WhmSkeleton
              variant="rounded"
              width="100%"
              height="30px"
              sx={{ marginBottom: "1rem" }}
            />
            <WhmSkeleton variant="rounded" width="100%" height="30px" />
          </WhmCardContent>
        </WhmCard>
      )}
    />
  );
};
